<template>
  <div class="settings__container">
    <h1 class="settings__header">Settings</h1>
    <ul class="nav-list">
      <li v-for="item of navLinks" class="nav-list__item">
        <router-link class="nav-list__item-link" :to="item.to">
          <span
            class="nav-list__item-link_active link__text"
            :class="{ active: $route.path === item.to }"
            >{{ item?.name }}</span
          >
        </router-link>
      </li>
    </ul>
    <router-view
      v-if="brains"
      :getChanges="getChanges"
      :brains="brains"
      :saveBrains="saveBrains"
    ></router-view>
    <ButtonWithLoadWebsite
      class="footer_bot_btn"
      title="Save"
      :isDisabled="saveDisabled"
      @onClick="saveBrains"
    />
  </div>
</template>

<script>
import ButtonWithLoadWebsite from "../components/shared/ButtonWithLoadWebsite.vue";
import { DataService } from "../config/dataService";
import store from "../vuex/store";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  components: {
    ButtonWithLoadWebsite,
  },
  data() {
    return {
      navLinks: [
        {
          name: "General",
          to: "/user/settings/general",
        },
        {
          name: "User Data",
          to: "/user/settings/user_data",
        },
        // {
        //   name: 'Chat models',
        //   to: '/user/settings/chat_models'
        // },
        // {
        //   name: 'Localization',
        //   to: '/user/settings/localization'
        // },
        {
          name: "Advanced",
          to: "/user/settings/advanced",
        },
      ],
      brains: null,
      // saveDisabled: true,
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    chosenWidget() {
      return store?.state?.users?.chosenWidget;
    },
    saveDisabled() {
      if (!this.brains) {
        return;
      }

      const globalChanges =
        JSON.stringify(this.brains) ===
        JSON.stringify(this.chosenWidget?.brains);
      const dataTypes =
        this.brains?.users?.userData !== "none" &&
        this.brains?.users?.dataTypes.length === 0;

      return globalChanges || dataTypes;
    },
  },
  methods: {
    getChanges(key, data) {
      this.brains = { ...this.brains, [key]: data };

      if (this.brains?.users?.userData === "none") {
        this.brains.users.dataTypes = [];
      }
    },
    async saveBrains() {
      try {
        store.dispatch("startLoading");
        const { data } = await DataService.patch(
          `${API_ENDPOINT}widget/update-brains/${this.chosenWidget.id}`,
          this.brains
        );

        if (data) {
          store.dispatch("setChosen", data);
          this.$toast.success("Widget successfully updated");
        }
      } catch ({ response }) {
        console.log(response?.data?.errorDescription);
        this.$toast.error(response?.data?.errorDescription || "Error occuped");
      } finally {
        store.dispatch("endLoading");
      }
    },
  },
  watch: {
    // brains: {
    //   handler (newBrains, oldBrains) {
    //     this.saveDisabled = JSON.stringify(newBrains) === JSON.stringify(this.chosenWidget.brains);
    //   },
    //   deep: true,
    // },
    chosenWidget: {
      handler(newChosenWidget) {
        this.brains = { ...newChosenWidget.brains };
      },
    },
  },
  mounted() {
    if (this.chosenWidget) {
      this.brains = { ...this.chosenWidget.brains };
    }
  },
};
</script>

<style scoped lang="scss">
.settings__container {
  position: relative;
  overflow: auto;
  height: calc(100vh - 66px);
  width: 100%;
  padding: 62px 38px 38px 38px;
}

.settings__header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 12px;
}
.nav-list {
  list-style: none;
  display: flex;
  padding: 0;
  column-gap: 32px;
  row-gap: 16px;
  margin-bottom: 36px;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    gap: 32px;
  }
}
.nav-list__item-link {
  text-decoration: none;
  background: transparent;
}

.nav-list__item-link_active {
  border-bottom: 1px solid transparent;
  transition: all 150ms linear;

  &.active {
    color: #3056d3;
    border-bottom: 1px solid #3056d3;
  }
}
.link__text {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
</style>
